import { automationRequestRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useCreateAutomationRequest = () =>
  useMutation<number, unknown, FormData>((data) =>
    automationRequestRepo.createAutomationRequest(data),
  );
